export enum HandoverStatusEnum {
  SUCCESS = "SUCCESS",
  PARTIAL_SUCCESS = "PARTIAL_SUCCESS",
  FAILED = "FAILED"
}

export interface HandoverStatusBadgeStyle {
  bg: string;
  text: string;
  icon: string;
}

export const HANDOVER_STATUS_BADGE_STYLE: Record<
  HandoverStatusEnum,
  HandoverStatusBadgeStyle
> = {
  [HandoverStatusEnum.SUCCESS]: {
    bg: "bg-green-lp-300",
    text: "text-green-lp-400",
    icon: require("@/app/ui/assets/svg/ics_f_check_circle.svg")
  },
  [HandoverStatusEnum.FAILED]: {
    bg: "bg-red-lp-3100",
    text: "text-red-lp-2400",
    icon: require("@/app/ui/assets/svg/x-circle.svg")
  },
  [HandoverStatusEnum.PARTIAL_SUCCESS]: {
    bg: "bg-yellow-lp-200",
    text: "text-yellow-lp-100",
    icon: require("@/app/ui/assets/svg/x-circle-yellow.svg")
  }
};

export const DEFAULT_HANDOVER_STATUS_BADGE_STYLE: HandoverStatusBadgeStyle = {
  bg: "bg-gray-lp-200",
  text: "text-black-lp-300",
  icon: ""
};

export function resolveHandoverStatusEnum(
  status: string
): HandoverStatusEnum | null {
  if (!status) {
    return null;
  }
  const upper = status.trim().toUpperCase();
  if (Object.values(HandoverStatusEnum).includes(upper as HandoverStatusEnum)) {
    return upper as HandoverStatusEnum;
  }
  return null;
}

export function getHandoverStatusBadgeStyle(
  status: string
): HandoverStatusBadgeStyle {
  const resolved = resolveHandoverStatusEnum(status);
  if (resolved && HANDOVER_STATUS_BADGE_STYLE[resolved]) {
    return HANDOVER_STATUS_BADGE_STYLE[resolved];
  }
  return DEFAULT_HANDOVER_STATUS_BADGE_STYLE;
}

export const DEFAULT_HANDOVER_STATUS_LABELS: Record<
  HandoverStatusEnum,
  string
> = {
  [HandoverStatusEnum.SUCCESS]: "Berhasil",
  [HandoverStatusEnum.FAILED]: "Gagal",
  [HandoverStatusEnum.PARTIAL_SUCCESS]: "Berhasil sebagian"
};

export function getHandoverStatusLabel(
  status: string,
  t?: (key: string) => string
): string {
  const resolved = resolveHandoverStatusEnum(status);
  if (!resolved) {
    return "—";
  }
  if (t) {
    const key = `handover.list.statusHandover.${resolved}`;
    const translated = t(key);
    if (translated && translated !== key) {
      return translated;
    }
  }
  return DEFAULT_HANDOVER_STATUS_LABELS[resolved] || "—";
}
